import React, {FC} from 'react';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';
import {BaseAccessoryProductItem} from 'components/baseProductItems/baseAccessoryProductItem/baseAccessoryProductItem';
import {RemoveItemButton} from 'components/baseProductItems/removeItemButton/removeItemButton';

import {NotificationBlock} from 'components/notificationBlock/notificationBlock';

import s from '../miniCartProductItem.scss';

type PropsType = {
    item: QuoteItemV2;
};

/**
 * Product Accessory Item for checkout and cart pages
 */
export const MiniCartAccessoryItem: FC<PropsType> = ({item}) => {
    const productHasNotification =
        item.product.stock?.isOutOfStock || item.product.stock?.isLowStock;

    return (
        <div className={s.cartItem}>
            <BaseAccessoryProductItem
                removeComponent={
                    __BUILD_TYPE__ === 'desktop' && <RemoveItemButton item={item} isMiniCart />
                }
                item={item}
            />
            <NotificationBlock item={item} productHasNotification={productHasNotification} />
        </div>
    );
};
